import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const pastTenseQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Selecciona la opción correcta: 'Ayer ___ al cine.'",
        options: ["voy", "fui", "iba", "iré"],
        correctAnswerIndex: 1,
        explanation: "'Fui' es el pretérito perfecto simple, usado para acciones puntuales en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Completa la oración: 'Cuando era niño, ___ en Barcelona.'",
        options: ["vivo", "vivía", "viví", "viviré"],
        correctAnswerIndex: 1,
        explanation: "'Vivía' es el imperfecto, usado para describir situaciones habituales o continuas en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Selecciona la forma correcta: 'Cuando llegué a la estación, el tren ya ___.",
        options: ["salió", "había salido", "salía", "saldrá"],
        correctAnswerIndex: 1,
        explanation: "'Había salido' es el pluscuamperfecto, usado para indicar que una acción ya había sucedido antes de otra acción pasada."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "¿Cuál es la forma correcta del verbo en la oración: 'Si hubiera sabido que venías, te ___ (invitar)'?",
        options: ["invitaría", "habría invitado", "hubiera invitado", "invité"],
        correctAnswerIndex: 1,
        explanation: "Aquí, usamos el condicional perfecto ('habría invitado') para hablar de una acción que podría haber ocurrido en el pasado, pero no ocurrió."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Completa la frase: 'Si no ___ (haberse ido), habría estado aquí para ayudarte.'",
        options: ["se fue", "se hubiera ido", "se irá", "fue"],
        correctAnswerIndex: 1,
        explanation: "Se utiliza el pluscuamperfecto de subjuntivo ('se hubiera ido') para indicar una acción que no ocurrió antes de otro evento pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Elige la opción correcta: 'El lunes pasado, ___ al médico.'",
        options: ["fui", "iba", "iría", "fuí"],
        correctAnswerIndex: 0,
        explanation: "'Fui' es el pretérito perfecto simple, usado para referirse a una acción puntual en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Selecciona la opción correcta: 'Cuando Juan era joven, siempre ___ a la playa.'",
        options: ["va", "fue", "iba", "irá"],
        correctAnswerIndex: 2,
        explanation: "'Iba' es el imperfecto, que se usa para describir acciones habituales o repetidas en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Elige la opción correcta: 'Cuando llegué al aeropuerto, el vuelo ya ___ (salir) hace una hora.'",
        options: ["salió", "había salido", "salía", "sale"],
        correctAnswerIndex: 1,
        explanation: "Se utiliza el pluscuamperfecto ('había salido') para hablar de una acción que ocurrió antes de otro evento en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Completa la oración: 'Cuando era niño, siempre ___ (ir) al parque los domingos.'",
        options: ["ibamos", "fuimos", "iríamos", "habíamos ido"],
        correctAnswerIndex: 0,
        explanation: "Usamos el imperfecto ('ibamos') para hablar de una acción habitual o repetida en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Selecciona la forma correcta: 'Si tú ___ (haber estudiar) más, habrías aprobado el examen.'",
        options: ["hubieras estudiado", "estudiaras", "habrías estudiado", "estudiabas"],
        correctAnswerIndex: 0,
        explanation: "El pluscuamperfecto de subjuntivo ('hubieras estudiado') se utiliza en una oración condicional en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Elige la opción correcta: 'Hace dos días, Juan me dijo que ya ___ (terminar) su tarea.'",
        options: ["terminaba", "había terminado", "terminó", "terminaría"],
        correctAnswerIndex: 1,
        explanation: "Aquí usamos el pluscuamperfecto ('había terminado') para indicar que la acción ocurrió antes de otro evento en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Completa la oración: 'No me di cuenta de que ___ (llegar) tarde a la reunión.'",
        options: ["llegué", "había llegado", "llegaba", "llegué"],
        correctAnswerIndex: 1,
        explanation: "Se usa el pluscuamperfecto ('había llegado') para indicar una acción anterior a otra en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Elige la mejor forma correcta del verbo: 'Yo ___ al cine cuando me llamaste.'",
        options: ["fue", "iba", "fui", "iré"],
        correctAnswerIndex: 1,
        explanation: "Esta construcción indica que la acción de 'ir al cine' estaba en curso cuando ocurrió la llamada."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Completa la frase: 'Ellos no ___ (llegar) a tiempo para la reunión ayer.'",
        options: ["llegaron", "habían llegado", "llegaban", "llegarán"],
        correctAnswerIndex: 1,
        explanation: "Se usa el pluscuamperfecto ('habían llegado') para hablar de una acción que ocurrió antes de otra en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Selecciona la opción correcta: 'Cuando Marta ___ (ver) el accidente, llamó a la policía.'",
        options: ["veía", "vio", "había visto", "vería"],
        correctAnswerIndex: 1,
        explanation: "Usamos el pretérito perfecto simple ('vio') para hablar de una acción puntual que ocurrió en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Elige la opción correcta: 'Si ellos ___ (haber saber) la verdad, no habrían tomado esa decisión.'",
        options: ["hubieran sabido", "sabían", "supieron", "habrían sabido"],
        correctAnswerIndex: 0,
        explanation: "El pluscuamperfecto de subjuntivo ('hubieran sabido') se usa en oraciones condicionales irreales en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Elige la opción correcta: 'El lunes pasado, ___ al médico.'",
        options: ["fue", "iba", "iría", "fuí"],
        correctAnswerIndex: 0,
        explanation: "'Fue' es el pretérito perfecto simple, usado para referirse a una acción puntual en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Selecciona la opción correcta: 'Cuando Juan era joven, siempre ___ a la playa.'",
        options: ["va", "fue", "iba", "irá"],
        correctAnswerIndex: 2,
        explanation: "'Iba' es el imperfecto, usado para describir acciones habituales en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Elige la forma correcta: 'Cuando llegamos a la fiesta, todos ya ___.",
        options: ["se fueron", "se habían ido", "iban", "han ido"],
        correctAnswerIndex: 1,
        explanation: "'Se habían ido' es el pluscuamperfecto, utilizado para indicar que una acción ocurrió antes que otra en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Selecciona la opción correcta: 'El año pasado, ___ de vacaciones a la playa.'",
        options: ["fueron", "irían", "habían ido", "iban"],
        correctAnswerIndex: 0,
        explanation: "'Fueron' es el pretérito indefinido, indicando una acción puntual completada en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Completa la oración: 'Cuando era pequeño, siempre ___ con mis amigos al parque.'",
        options: ["juego", "jugaba", "jugué", "jugaré"],
        correctAnswerIndex: 1,
        explanation: "'Jugaba' es el imperfecto, utilizado para describir acciones habituales o continuas en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Selecciona la respuesta correcta: 'Nosotros ___ una película ayer.'",
        options: ["vemos", "veíamos", "vimos", "veremos"],
        correctAnswerIndex: 2,
        explanation: "'Vimos' es el pretérito perfecto simple, utilizado para acciones completas en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "¿Cuál es la opción correcta? 'Hace un año, ___ en el campo todo el día.'",
        options: ["trabajasteis", "trabajabais", "trabajaron", "trabajaríais"],
        correctAnswerIndex: 0,
        explanation: "'Trabajasteis' es el pretérito indefinido de 'trabajar' en la forma de 'vosotros', que indica una acción puntual completada en el pasado."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Completa la frase: 'Cuando éramos niños, siempre ___ juntos.'",
        options: ["jugamos", "jugábamos", "jugaremos", "juegebamos"],
        correctAnswerIndex: 1,
        explanation: "'Jugábamos' es el imperfecto, que se usa para describir acciones habituales o repetidas."
    },
    {
        category: QuizCategory.PAST_TENSE,
        questionText: "Elige la forma correcta: 'Ellos ___ a casa cuando yo llegué.'",
        options: ["han llegado", "llegaron", "llegaban", "llegarán"],
        correctAnswerIndex: 1,
        explanation: "'Llegaron' es el pretérito perfecto simple, utilizado para una acción completada en el pasado."
    }
];

export default pastTenseQuestions;